/* eslint-disable no-unused-vars */

import { CONSTANT } from '../../constant/index';
import { message } from 'antd';
import DataTable from '@/containers/data_table_ml/DataTable';
import ButtonML from '@/components/button_ml/ButtonML';
import Popconfirm from '@/containers/popconfirm/Popconfirm';
import Dropdown from '../components/dropdown_ml/Dropdown';
import styles from './ModalDetail.less?modules';
import TableLinkML from '@/containers/data_table_ml/table_link_ml/TableLinkML';
import { history } from 'umi';
import { useTrigger } from '@/utils/comHook.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';

const TablePage = (props) => {
  const { loading, editableGetFecth } = props || {};
  // const { editable } = props.location.query;
  const deleteTrigger = useTrigger();

  const menuClick = (a, b) => {
    props.menuClick(a, b);
  };
  const handleMemberDelete = (e) => {
    props.deleteModalField(e);
  };
  //进入三级目录规则详情
  const handleDetail = (record) => {
    history.push({
      pathname: '/bre/mm/md/cfg',
      query: {
        id: record.id,
        name: record.fieldName,
        editable: record.editable,
      },
    });
  };
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 40,
    },
    {
      title: '字段类别',
      dataIndex: 'fieldPackage',
      key: 'fieldPackage',
      width: 80,
    },
    {
      title: '字段名称',
      dataIndex: 'fieldName',
      key: 'fieldName',
      width: 100,
      render: (text, record) => (
        <span>
          <TableLinkML text={text} handleClick={() => handleDetail(record)} />
        </span>
      ),
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 100,
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 100,
    },
    {
      title: '字段状态',
      dataIndex: 'fieldStatus',
      key: 'fieldStatus',
      width: 100,
      render: (recor) => {
        const result = CONSTANT.statusList.find((item) => item.value === recor);
        if (result) {
          return result.value ? result.name : '';
        }
        return recor;
      },
    },
    {
      title: '操作',
      width: 120,
      render: (recor) => {
        return (
          <div className={styles.handle_btn}>
            {/* <ButtonML size="large" value="编辑" onClick={() => edit(recor)} /> */}
            <ModalConfirmML
              title="是否确认删除?"
              handleOk={() => handleMemberDelete(recor)}
              handleCancel={deleteTrigger.close}
              visible={deleteTrigger.visible}
              value="删除"
              icon={<ExclamationCircleOutlined />}
              disabled={String(editableGetFecth) === 'false'}
            />
            {/* <Dropdown
              size="large"
              title="其他操作"
              fontsize="14px"
              item={recor}
              menuClick={menuClick}
              disabled={String(editableGetFecth) === 'false'}
            /> */}
          </div>
        );
      },
    },
  ];
  return (
    <>
      <DataTable
        className="demo-test"
        style={{ minWidth: '1547px' }}
        columns={columns}
        rowSelection={false}
        scroll={{ y: 'calc(100vh - 156px - 3rem)' }}
        loading={loading}
        dataSource={props.tableData instanceof Array ? props.tableData : []}
        changePage={(a) => {
          props.pageNumChange(a);
        }}
        changePageSize={(a) => {
          props.pageSizeChange(a);
        }}
      />
    </>
  );
};
export default TablePage;
